import { useState } from 'react';
import ReactPlayer from 'react-player';
import { messageLog } from 'utilities/helpers/logger/message-logger';
import { useYouTubePlayerVisibility } from './useYouTubePlayerVisibility';
import { AdvertEmbeddedComponentProps } from 'components/advert/advert-embedded-component';

export interface YouTubePlayerProps {
  playlist: {
    id: string;
    title: string;
  };
  advert: AdvertEmbeddedComponentProps
  errorMessage?: string;
}

export const YouTubePlayer = ({ playlist, errorMessage }: Omit<YouTubePlayerProps, 'advert'>) => {
  const [hasError, setHasError] = useState(false);
  const [setContainer, isVisible] = useYouTubePlayerVisibility();

  const handleError = (error: React.SyntheticEvent<HTMLVideoElement, Event>) => {
    messageLog.error('YouTube Player Error:', ['msg', error]);
    setHasError(true);
  };

  if (hasError) {
    return (
      <div className="error-message" style={{ padding: '20px', textAlign: 'center' }}>
        <p>{errorMessage ?? 'Videos are unavailable at this time.'}</p>
      </div>
    );
  }

  return (
    <div ref={setContainer} style={{ maxWidth: '1500px' }}>
      <ReactPlayer
        src={`https://www.youtube.com/playlist?list=${playlist.id}&rel=0&modestbranding=1`}
        controls={true}
        style={{ width: '100%', minWidth: '100%', height: 'auto', aspectRatio: '500/280' }}
        onError={handleError}
        onReady={() => {
          setHasError(false);
        }}
        playsInline={true}
        playing={!isVisible ? false : undefined}
      />
    </div>
  );
};
